<template>
  <div class="ty-main">
    <div class="ty-card">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-radio-group v-model="timeRadio" @change="timeRadioChange">
            <el-radio-button label="昨天"></el-radio-button>
            <el-radio-button label="近7天"></el-radio-button>
            <el-radio-button label="近30天"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="scopeDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTime"
            :picker-options="pickerOptions"
            :default-value="Date.now() - 30 * 24 * 3600 * 1000"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="部门:">
          <el-input
            v-model="department_name"
            @focus="departmentShow2"
            @clear="setValueNull01"
            placeholder="请选择部门"
            clearable>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="20" type="flex" justify="center" align="middle">
    <el-col :span="4">
            <div style="box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);">
                <div class="fhusfh grid-content bg-purple">
                    <div class="content">
                        <span>{{intervalDay}}天</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>平均首次回复时长</span>
                    </div>
                    <div class="time">
                        <span>{{beginDate}} - {{endDate}}</span>
                    </div>
                    <div class="stace">
                      <span>{{magicCube.averageFirstReplyTimePrefix}}<span class="times" v-if="magicCube.averageFirstReplyTimePrefix !== '-'">{{magicCube.averageFirstReplyTimeSuffix}}</span></span>
                      <!-- <span v-if="this.hour > 0">{{hour}}<span class="times">时</span></span>
                      <span v-if="this.min > 0">{{min}}<span class="times">分</span></span>
                      <span v-if="this.seckill >= 0">{{seckill}}<span class="times">秒</span></span>-->
                    </div>
                </div>
            </div>
            <div class="asda0"></div>
        </el-col>
        <el-col :span="7">
            <div style="box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);">
                <el-row>
                    <el-col :span="12">
                        <div class="fhusfh01 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>回复客户次数</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.replyCustomerNum}}</span><span class="dan" v-if="magicCube.replyCustomerNum !== '-'">人</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="fhusfh01 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>回复客户率</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.replyCustomerRate}}</span><span class="dan" v-if="magicCube.replyCustomerRate !== '-'">%</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="asda"></div>
        </el-col>
        <el-col :span="7">
            <div style="box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);">
                <el-row>
                    <el-col :span="12">
                        <div class="fhusfh02 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>未回复客户次数</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.notReplyCustomerNum}}</span><span class="dan" v-if="magicCube.notReplyCustomerNum !== '-'">人</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="fhusfh02 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>未回复客户率</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.notReplyCustomerRate}}</span><span class="dan" v-if="magicCube.notReplyCustomerRate !== '-'">%</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="asda01"></div>
        </el-col>
        <el-col :span="7">
            <div style="box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);">
                <el-row>
                    <el-col :span="12">
                        <div class="fhusfh03 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>服务活跃客户数</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.serviceActiveCustomerNum}}</span><span class="dan" v-if="magicCube.serviceActiveCustomerNum !== '-'">人</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="fhusfh03 grid-content bg-purple">
                            <div class="content">
                                <span>{{intervalDay}}天</span>
                                <el-divider direction="vertical"></el-divider>
                                <span>服务活跃客户率</span>
                            </div>
                            <div class="time">
                                <span>{{beginDate}} - {{endDate}}</span>
                            </div>
                            <div class="stace">
                                <span>{{magicCube.serviceActiveCustomerRate}}</span><span class="dan" v-if="magicCube.serviceActiveCustomerRate !== '-'">%</span>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="asda02"></div>
        </el-col>
    </el-row>
    <div class="echarts">
        <div class="ding">
            <div class="tab-item"
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: indexs === index }"
            @click="tabChange(index)">
            {{ item.title }}
            </div>
        </div>
        <div v-loading="loading03">
          <EchartsList :xData="xData" :yData="yData" v-if="indexs === 0"></EchartsList>
          <EchartsData :xData2="xData2" :yData2="yData2" v-if="indexs === 1"></EchartsData>
        </div>
    </div>
    <div class="ty-content white">
      <h3>员工统计</h3>
      <el-form :inline="true" class="query-form" :model="form" onsubmit="return false;" style="text-align: left;">
        <el-form-item label="员工:">
          <el-input
          v-model="form.name"
          placeholder="请选择员工"
          @focus="openSelectDialog"
          clearable
          @clear="setValueNull"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch01(form)">查询</el-button>
        </el-form-item>
        <el-button class="fr mb20" type="primary" @click="addStaff" :disabled="disabled">导出</el-button>
      </el-form>
      <el-table
        :data="tableData"
        empty-text='暂无数据'
        style="width: 100%;margin-top: 20px;"
        max-height="604"
        id="table"
        @sort-change="sortChange">
          <el-table-column label="员工" width="300" fixed>
           <template slot-scope="scope">
              <div v-if="scope.row.staffName.length === 0"><span>未知员工</span></div>
              <div v-else>
                <el-popover
                  v-if="scope.row.staffName.length > 10"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>
                    <span>{{scope.row.staffName}}</span>
                    <span v-if="scope.row.userSessionStatus === 1" class="tag01" style="line-height: 16px;">存档</span>
                    <span v-if="scope.row.userSessionStatus === -1" class="tag" style="line-height: 16px;">存档关闭</span>
                    <span v-if="scope.row.userStatus === -1" class="tag">离职</span>
                  </div>
                  <span slot="reference" style="color: #303133;">{{scope.row.staffName | ellipsis}}
                  <span v-if="scope.row.userSessionStatus === 1" class="tag01" style="line-height: 16px;">存档</span>
                    <span v-if="scope.row.userSessionStatus === -1" class="tag" style="line-height: 16px;">存档关闭</span>
                    <span v-if="scope.row.userStatus === -1" class="tag">离职</span></span>
                </el-popover>
                <span v-else>
                  <span>{{ scope.row.staffName || '-'}}</span>
                  <span v-if="scope.row.userSessionStatus === 1" class="tag01" style="line-height: 16px;">存档</span>
                  <span v-if="scope.row.userSessionStatus === -1" class="tag" style="line-height: 16px;">存档关闭</span>
                  <span v-if="scope.row.userStatus === -1" class="tag">离职</span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="部门" width="260" fixed>
           <template slot-scope="scope">
              <div v-if="scope.row.departmentName.length > 0">
                <el-popover
                  v-if="scope.row.departmentName.length > 16"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.departmentName}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.departmentName | ellipsiss}}</span>
                </el-popover>
                <span v-else>{{scope.row.departmentName}}</span>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="平均首次回复时长" prop="averageFirstReplyTime" sortable="custom" min-width="200"> </el-table-column>
          <el-table-column label="回复客户次数" prop="replyCustomerNum" min-width="180" sortable="custom"> </el-table-column>
          <el-table-column label="回复客户率" min-width="150" sortable="custom">
            <template slot-scope="scope">
              {{scope.row.replyCustomerRate}}%
            </template>
          </el-table-column>
          <el-table-column label="未回复客户次数" prop="notReplyCustomerNum" sortable="custom" min-width="210"></el-table-column>
          <el-table-column label="未回复客户率" sortable="custom" min-width="210">
            <template slot-scope="scope">
              {{scope.row.notReplyCustomerRate}}%
            </template>
          </el-table-column>
          <el-table-column label="服务活跃客户数" prop="serviceActiveCustomerNum" sortable="custom" min-width="210"> </el-table-column>
          <el-table-column label="服务活跃客户率" min-width="210" sortable="custom">
            <template slot-scope="scope">
              {{scope.row.serviceActiveCustomerRate}}%
            </template>
          </el-table-column>
          <template #empty>
            <el-empty v-loading="loading"></el-empty>
          </template>
        </el-table>
        <div class="huji01" v-if="tableData.length !== 0">
          <el-button class="up-btn" type="text" @click="refresh01" :disabled="isUpOver01">
            {{ isUpOver01 ? '已加载全部' : '点击加载' }}
          </el-button>
          <img v-if="isUpOver01 === false" src="../../assets/images/xia.png" width="12" />
        </div>
        <Peoples
          v-if="isShow"
          :isShow="isShow"
          @check-user="checkUser"
          :checkeds="checkedEmployees"
        ></Peoples>
        <Divisional
          v-if="departmentShow"
          :departmentShow="departmentShow"
          @check-depart="checkDepart"
          :department="departmentData"
          :checkeds="checkedDepartments"
        ></Divisional>
      </div>
    </div>
</template>
<script>
import Divisional from '../../components/divisional'
import EchartsData from './components/EchartsData'
import EchartsList from './components/EchartsList'
import Peoples from '../../components/peoples'
import { downloadFile } from '../../utils/downloadFile.js'
export default {
    components: {
      Divisional,
      EchartsData,
      EchartsList,
      Peoples
    },
  data() {
    return {
      downloadFile,
      timeRadio: '昨天',
      pickerOptions: {
        onPick: (obj) => {
            this.pickerMinDate = new Date(obj.minDate).getTime()
        },
        disabledDate: (time) => {
            if (this.pickerMinDate) {
                const day1 = 30 * 24 * 3600 * 1000
                const maxTime = this.pickerMinDate + day1
                const minTime = this.pickerMinDate - day1
                return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000
            } else {
                return time.getTime() > Date.now() + -1 * 24 * 3600 * 1000
            }
        }
      },
      pickerOpti: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() + -1 * 24 * 3600 * 1000
        }
      },
      tabs: [
        {
          title: '数量'
        },
        {
          title: '比率'
        }
      ],
      form: {
        name: ''
      },
      indexs: 0,
      department_name: '',
      scopeDate: '',
      startDate: '',
      beginDate: '',
      intervalDay: '',
      disabled: true,
      endDate: '',
      chart_type: 3,
      xData: [],
      yData: [],
      xData2: [],
      yData2: [],
      staffUserIds: [],
      depapart_id: [],
      departmentShow: false,
      tableData: [],
      loading: false,
      loading03: false,
      isUpOver01: false,
      isShow: false,
      checkedEmployees: [],
      dateType: 3,
      otherDate: '',
      page: 1,
      magicCube: {},
      orderField: 6,
      orderType: 2,
      departmentData: [],
      checkedDepartments: [],
      hour: '',
      min: '',
      seckill: '',
      downWhere: ''
    }
  },
  mounted() {
    // this.startDate = this.$moment(this.scopeDate[0]).format('YYYY-MM-DD')
    // this.endDate = this.$moment(this.scopeDate[1]).format('YYYY-MM-DD')
    // this.otherDate = this.startDate + 'TO' + this.endDate
    this.getList()
    this.getData()
    this.getDepartment()
  },
  // watch: {
  //   scopeDate(val) {
  //     if (val) {
  //     } else {
  //     }
  //   }
  // },
  methods: {
    // 获取部门表
    getDepartment() {
        this.$api.get('/api/v1/inherit/get-department', {
          user_id: sessionStorage.getItem('user_id')
        }).then(response => {
          let arr = []
          arr = response.data
          this.departmentData = arr || []
        })
    },
    getList() {
      this.loading03 = true
      this.$api
        .post('api/system/statisticsByCustomerService/getStaffData', {
          dateType: this.dateType,
          otherDate: this.otherDate,
          departmentIds: this.depapart_id.toString()
        })
        .then(res => {
          const arr = []
          const arr1 = []
          if (res) {
            this.beginDate = res.beginDate
            this.endDate = res.endDate
            this.intervalDay = res.intervalDay
            this.magicCube = res.magicCube
            // const a = res.magicCube.averageFirstReplyTime
            // this.hour = parseInt(a / 3600) < 10 ? '0' + parseInt(a / 3600) : parseInt(a / 3600)
            // this.min = parseInt(a % 3600 / 60) < 10 ? '0' + parseInt(a % 3600 / 60) : parseInt(a % 3600 / 60)
            // this.seckill = parseInt(a % 3600 % 60) < 10 ? '0' + parseInt(a % 3600 % 60) : parseInt(a % 3600 % 60)
            for (const key in res.lineChartNumArr) {
              arr.push(key)
              this.yData.push(res.lineChartNumArr[key])
            }
            arr.forEach(l => {
              this.xData.push(l.slice(0, 5))
            })
            for (const key in res.lineChartRateArr) {
              arr1.push(key)
              this.yData2.push(res.lineChartRateArr[key])
            }
            arr1.forEach(l => {
              this.xData2.push(l.slice(0, 5))
            })
            for (const key in res.magicCube) {
              if (res.magicCube[key] === '-') {
                this.$message.warning('数据正在计算中，请稍后查看。')
                this.loading03 = false
                return false
              }
            }
            this.loading03 = false
          } else {
            this.loading03 = false
          }
        })
    },
    getData() {
      this.loading = true
      this.$api
        .post('api/system/statisticsByCustomerService/getStaffPaging', {
          dateType: this.dateType,
          otherDate: this.otherDate,
          departmentIds: this.depapart_id.toString(),
          staffUserIds: this.staffUserIds.toString(),
          orderField: this.orderField,
          orderType: this.orderType,
          page: this.page,
          pageSize: 10
        })
        .then(res => {
          if (res) {
            if (res.page.length === 10) {
              const arr = res.page
              this.tableData = this.tableData.concat(arr)
              this.loading = false
              this.disabled = false
              this.isUpOver01 = false
              this.downWhere = res.downWhere
            } else if (res.page.length > 0 && res.page.length < 10) {
              const arr = res.page
              this.tableData = this.tableData.concat(arr)
              this.loading = false
              this.disabled = false
              this.isUpOver01 = true
              this.downWhere = res.downWhere
            } else {
              this.isUpOver01 = true
              this.loading = false
            }
          } else {
            this.loading = false
          }
        })
    },
    getTime() {
      if (this.scopeDate && this.scopeDate.length > 0) {
        this.timeRadio = ''
        this.dateType = ''
        this.startDate = this.$moment(this.scopeDate[0]).format('YYYY-MM-DD')
        this.endDate = this.$moment(this.scopeDate[1]).format('YYYY-MM-DD')
        this.otherDate = this.startDate + 'TO' + this.endDate
      } else {
       this.tian = '1'
        this.timeRadio = '昨天'
        this.startDate = this.$moment().subtract('days', 1).format('YYYY-MM-DD')
        this.endDate = this.$moment().subtract('days', 1).format('YYYY-MM-DD')
        this.tableData = []
        this.xData = []
        this.yData = []
        this.xData2 = []
        this.yData2 = []
        this.dateType = 3
        this.otherDate = ''
        this.getList()
        this.getData()
      }
    },
    onSearch() {
      this.page = 1
      this.tableData = []
      this.xData = []
      this.yData = []
      this.xData2 = []
      this.yData2 = []
      this.getList()
      this.getDataStatus()
      this.getData()
    },
    checkDepart(checkedDepartment) {
      this.checkedDepartments = []
      this.department_name = []
      this.depapart_name = []
      this.depapart_id = []
      if (checkedDepartment && checkedDepartment.length > 0) {
        this.checkedDepartments = checkedDepartment
        checkedDepartment.forEach(k => {
          this.depapart_id.push(k.value)
          this.depapart_name.push(k.label)
        })
        this.department_name = this.depapart_name.toString()
      } else {
        this.getDepartment()
      }
      this.departmentShow = false
    },
    tabChange(index) {
      this.xData = []
      this.yData = []
      this.xData2 = []
      this.yData2 = []
      this.indexs = index
      this.getList()
    },
    departmentShow2() {
      this.depapart_id = []
      this.departmentShow = true
    },
    setValueNull01() {
      this.depapart_id = []
      this.checkedDepartments = []
      this.getDepartment()
    },
    openSelectDialog() {
      this.isShow = true
    },
    setValueNull() {
      this.staffUserIds = []
      this.tableData = []
      this.page = 1
      this.checkedEmployees = []
      this.getData()
    },
    onSearch01() {
      this.tableData = []
      this.page = 1
      this.getDataStatus()
      this.getData()
    },
    refresh01() {
      this.page = this.page + 1
      this.getData()
    },
    checkUser(checkedEmployee) {
      this.form.name = ''
      this.staffUserIds = []
      const arr = []
      if (checkedEmployee && checkedEmployee.length > 0) {
        this.checkedEmployees = checkedEmployee
        checkedEmployee.forEach(k => {
          arr.push(k.name)
          this.staffUserIds.push(k.id)
        })
        this.form.name = arr.toString()
        this.isShow = false
      } else {
        this.isShow = false
      }
    },
    getDataStatus() {
      this.$api.post('/api/system/statisticsByFollowUpActive/getDataStatus', {
          dateType: this.dateType,
          otherDate: this.otherDate,
          departmentIds: this.depapart_id.toString(),
          staffUserIds: this.staffUserIds.toString(),
          orderField: this.orderField,
          orderType: this.orderType,
          page: this.page,
          pageSize: 10
      }).then(res => {
      })
    },
    timeRadioChange() {
      this.otherDate = ''
      this.tableData = []
      this.scopeDate = ''
      this.xData = []
      this.yData = []
      this.xData2 = []
      this.yData2 = []
      if (this.timeRadio === '近7天') {
        this.dateType = 1
        this.getList()
        this.getData()
      }
      if (this.timeRadio === '近30天') {
        this.dateType = 2
        this.getList()
        this.getData()
      }
      if (this.timeRadio === '昨天') {
        this.dateType = 3
        this.getList()
        this.getData()
      }
    },
    sortChange(column) {
      this.page = 1
      if (column.column.label === '平均首次回复时长') {
        this.tableData = []
        this.orderField = 1
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '回复客户次数') {
        this.tableData = []
        this.orderField = 2
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '回复客户率') {
        this.tableData = []
        this.orderField = 3
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '未回复客户次数') {
        this.tableData = []
        this.orderField = 4
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '未回复客户率') {
        this.tableData = []
        this.orderField = 5
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '服务活跃客户数') {
        this.tableData = []
        this.orderField = 6
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
      if (column.column.label === '服务活跃客户率') {
        this.tableData = []
        this.orderField = 7
        if (column.column.order === 'ascending') {
          this.orderType = 1
        } else {
          this.orderType = 2
        }
        this.getData()
      }
    },
    addStaff() {
      this.$api.post('api/system/statisticsByCustomerService/getStaffDown', {
        downWhere: encodeURIComponent(this.downWhere),
        orderField: this.orderField,
        orderType: this.orderType
      })
      .then(res => {
        this.$message({
          message: '导出的文件请到菜单栏中的【下载中心】去下载',
          type: 'success'
        })
        // window.location.href = res
        // const filename = '员工统计.xlsx'
        // downloadFile(res, filename)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ty-card{
  height: 40px;
}
.ty-main .ty-content.white{
    margin-top: 20px;
}
.echarts{
    margin-top: -60px;
}
.fhusfh{
    height: 100px;
    background: #FFFFFF;
    padding-top: 20px;
    text-align: center;
    // box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);
    border-top: 10px solid #5C7BD9;
    border-bottom: 2px solid #5C7BD9;
    .content{
        color: #000000;
        font-weight: 550;
        font-size: 16px;
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .content{
        font-size: 14px;
      }
    }
    .time{
        margin-top: 6px;
        color: #000000;
        font-weight: 400;
        font-size: 12px;
    }
    .stace{
        margin-top: 15px;
        font-weight: 550;
        color: #000000;
        font-size: 30px;
        .dan{
            font-size: 14px;
        }
        @media screen and (min-width:1366px) and (max-width:1440px){
        .stace{
            font-size: 12px;
          }
        }
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .stace{
        font-size: 24px;
      }
    }
}
.asda{
    position: relative;
    top: -100px;
    left: 50%;
    width: 1px;
    height: 80px;
    background: #FF7171;
    opacity: 1;
}
.fhusfh01{
    height: 100px;
    background: #FFFFFF;
    padding-top: 20px;
    text-align: center;
    // box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);
    border-top: 10px solid #FF7171;
    border-bottom: 2px solid #FF7171;
    .content{
        color: #000000;
        font-weight: 550;
        font-size: 16px;
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .content{
        font-size: 14px;
      }
    }
    .time{
        margin-top: 6px;
        color: #000000;
        font-weight: 400;
        font-size: 12px;
    }
    .stace{
        margin-top: 15px;
        font-weight: 550;
        color: #000000;
        font-size: 30px;
        .dan{
            font-size: 14px;
        }
        @media screen and (min-width:1366px) and (max-width:1440px){
        .dan{
          font-size: 12px;
        }
    }
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .stace{
        font-size: 24px;
      }
    }

}
.fhusfh02{
    height: 100px;
    background: #FFFFFF;
    padding-top: 20px;
    text-align: center;
    // box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);
    border-top: 10px solid #9FDF81;
    border-bottom: 2px solid #9FDF81;
    .content{
        color: #000000;
        font-weight: 550;
        font-size: 16px;
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .content{
        font-size: 14px;
      }
    }
    .time{
        margin-top: 6px;
        color: #000000;
        font-weight: 400;
        font-size: 12px;
    }
    .stace{
        margin-top: 15px;
        font-weight: 550;
        color: #000000;
        font-size: 30px;
        .dan{
            font-size: 14px;
        }
        @media screen and (min-width:1366px) and (max-width:1440px){
        .stace{
            font-size: 12px;
          }
        }
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .stace{
        font-size: 24px;
      }
    }
}
.fhusfh03{
    height: 100px;
    background: #FFFFFF;
    padding-top: 20px;
    text-align: center;
    // box-shadow: 0px 2px 10px 1px rgba(2,47,50,0.1);
    border-top: 10px solid #9F58DB;
    border-bottom: 2px solid #9F58DB;
    .content{
        color: #000000;
        font-weight: 550;
        font-size: 16px;
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .content{
        font-size: 14px;
      }
    }
    .time{
        margin-top: 6px;
        color: #000000;
        font-weight: 400;
        font-size: 12px;
    }
    .stace{
        margin-top: 15px;
        font-weight: 550;
        color: #000000;
        font-size: 30px;
        .dan{
            font-size: 14px;
        }
        @media screen and (min-width:1366px) and (max-width:1440px){
        .content{
            font-size: 12px;
          }
        }
    }
    @media screen and (min-width:1366px) and (max-width:1440px){
    .stace{
        font-size: 24px;
      }
    }
}
.asda0{
    position: relative;
    top: -100px;
    left: 50%;
    width: 0;
    height: 80px;
    opacity: 1;
}
.asda01{
    position: relative;
    top: -100px;
    left: 50%;
    width: 1px;
    height: 80px;
    background: #9FDF81;
    opacity: 1;
}
.asda02{
    position: relative;
    top: -100px;
    left: 50%;
    width: 1px;
    height: 80px;
    background: #9F58DB;
    opacity: 1;
}
.echarts{
   margin-top: -95px;
  .ding {
    display: flex;
    width: 112px;
    position: relative;
    top: 60px;
    left: 90%;
    color: #204A9E;
    border-radius: 4px;
    border: 1px solid #204A9E;
    z-index: 999;
    .tab-item {
      width: 50%;
      padding: 9px 11px;
      text-align: center;
      // line-height: 32px;
      transition: all 0.3s;
      cursor: pointer;
    }
    .active {
        width: 50%;
        margin-top: -0.5px;
        margin-right: -0.5px;
        color: #FFF;
        background-color: #204a9e;
    }
    // .active::after {
    //   content: "";
    //   position: absolute;
    //   top: 3px;
    //   left: -10px;
    //   width: 2px;
    //   height: 60%;
    //   background: #204a9e;
    //   border-radius: 2px;
    // }
  }
  @media screen and (width: 1366px){
    .ding {
      position: relative;
        top: 55px;
        left: 87%;
    }
  }
  @media screen and (width: 1440px){
    .ding {
      position: relative;
        top: 55px;
        left: 87.5%;
    }
  }
  @media screen and (width: 1600px){
    .ding {
      position: relative;
        top: 55px;
        left: 88.6%;
    }
  }
  @media screen and (width: 1680px){
    .ding {
      position: relative;
        top: 55px;
        left: 89.2%;
    }
  }
  @media screen and (width: 1920px){
    .ding {
      position: relative;
        top: 55px;
        left: 90.2%;
    }
  }
}
.ty-tabs {
  width: 100%;
  height: 80px;
  margin-top: 20px;
  box-shadow: 0px 2px 10px rgba(2, 47, 50, 0.1);
  opacity: 1;
  background-color: white;
  display: flex;
  .wei{
    display: flex;
    .tab-item{
      width: 89px;
      height: 80px;
      text-align: center;
      line-height: 80px;
      font-weight: 500;
      margin-left: 10px;
      font-size: 16px;
      color: #303133;
      text-align: center;
    }
    .tab-item:hover{
      color: #204A9E;
    }
    .active {
      color: #204a9e;
      font-size: 18px;
      font-weight: 550;
    }
    .active::before {
      content: "";
      position: absolute;
      top: 77px;
      left: 4px;
      width: 80px;
      height: 3px;
      background: #204A9E;
      border-radius: 3px 3px 0px 0px;
    }
  }
}
::v-deep .el-form-item__label {
  margin-bottom: 0px;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  border-left: 1px solid #204a9e;
  background-color: #204a9e;
  border-color: #204a9e;
}
::v-deep .el-radio-group{
  display: flex;
}
.el-divider--vertical {
    background: #000000;
}
h3{
  font-size: 18px;
  font-weight: 550;
  color: #041D34;
  padding-bottom: 12px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E4E7ED;
}
.times{
  font-size: 12px;
  font-weight: 550;
}

</style>
